module.exports = __webpack_public_path__ + "static/media/dollar_white.0f8ac51a.svg";